import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import Icons from "../../icons";
import "./dropdown.scss";

const DropDown = ({
  autoid,
  startIcon = null,
  options,
  onSelection,
  identifier,
  disabled,
  title = "",
  wrapperClass,
  parentClass="",
  hideSelectedOption = false,
  value,
  name,
  toFetchSelectedValue,
  manageSchedule = false,
  noActionNeeded = false,
  alwaysShowIcon = false,
  customId = "",
  radioIcon = false,
  isSorting = false,
  finalSortingKey = "",
  showListTitle = false,
  fleetActionPlaceholder=false,
  showListTooltip = false
}) => {
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [optionList, setOptionList] = useState([]);
  const dropdownRef = useRef();

  const getLabel = () => {
    if (selectedValue === "") return "";
    const selectedOption = options.find((item) => {
      return item.value == selectedValue});
    if (selectedOption) return selectedOption.label;
    return "";
  };
  const handleOpen = (e) => {
    dropdownRef.current.focus();
    e.preventDefault();
    e.stopPropagation();
    if (optionList.length > 0) {
      setOpenDropdown(!openDropdown);
    }
  };
  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpenDropdown(false);
    }
  };
  const filterOptions = (val) => {
    const filteredOptions = options.filter((item) => item.value !== val);
    if (hideSelectedOption) {
      setOptionList(filteredOptions);
    } else {
      setOptionList(options);
    }
  };
  const handleChange = (item) => {
    setOpenDropdown(false);
    setSelectedValue(item.value);
    onSelection(item.value, identifier);
    filterOptions(item.value);
    setSelectedLabel(item.label);
  };

  useEffect(() => {
    toFetchSelectedValue(selectedLabel, selectedValue);
  }, [selectedLabel, selectedValue, toFetchSelectedValue]);

  useEffect(() => {
    if (options.length > 0) {
      filterOptions(value);
      setSelectedValue(value);
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [options,value]);

  return (
    <div
      title={title}
      className={classNames("dropDownWrapper", wrapperClass, {
        active: openDropdown,
      })}
      style={{
        cursor: optionList.length > 0 && !disabled ? "pointer" : "not-allowed",
      }}
      name={name}
      onClick={(e)=>{
        disabled ? e.stopPropagation() : handleOpen(e)
      }}
      onDoubleClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      ref={dropdownRef}
      id={
        radioIcon
          ? openDropdown
            ? `${autoid}_active`
            : `${autoid}`
          : `${autoid}`
      }
    >
      <div className="d-flex align-items-center justify-content-between fluid container">
        <div className="d-flex align-items-center fluid me-2">
          {startIcon}
          <span className="selected_label_name">
            {manageSchedule === true
              ? getLabel() === undefined || getLabel() === ""
                ? "Select a Schedule"
                : getLabel()
              : getLabel()}
          </span>
        </div>
        <div>
          {optionList.length > 0 &&
          openDropdown &&
          (!disabled || alwaysShowIcon) ? (
            <span id="upArrowIcon">{Icons.chevronUpArrowIcon}</span>
          ) : (!disabled || alwaysShowIcon) && optionList.length > 0 ? (
            <span id="downArrowIcon">{Icons.chevronDownArrowIcon}</span>
          ) : (
            ""
          )}
        </div>
      </div>
      <ul
        className={isSorting ? `dropdownList sorting ${parentClass}` : `dropdownList ${parentClass}`}
        id={`${customId}dropdownListId`}
      >
        {optionList.length > 0 &&
          optionList.map((item, index) => (
            <li
              id={`li_${index}`}
              key={`${autoid}_dropdown_list_${index + 1}`}
              onClick={noActionNeeded ? undefined : () => handleChange(item)}
              title={showListTitle ? item.label : showListTooltip ? item.tooltip : ""}
            >
              {radioIcon ? (
                item.label === finalSortingKey ? (
                  <span
                    className={classNames("radioIcon", {
                      "selected-radio": item.value === selectedValue,
                    })}
                  >
                    {Icons.radioFilledBtn}
                  </span>
                ) : radioIcon ? (
                  <span
                    className={classNames("radioIcon", {
                      "selected-radio": item.value === selectedValue,
                    })}
                  >
                    {Icons.radioBtnIcon}
                  </span>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
              <span
                className={
                  selectedLabel === item.label
                    ? `label_${index} selected`
                    : `label_${index}`
                }
                id={`label_${index}_Id`}
              >
                {item.label}
              </span>
            </li>
          ))}
      </ul>
    </div>
  );
};

DropDown.defaultProps = {
  toFetchSelectedValue: (arg) => {},
};

export default DropDown;
